var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useContext, useEffect, useState } from 'react';
import { GlobalContext } from '../context/global';
import { useInput } from './common/use-input';
import { appEnv } from '@cta-portal/webapp-common/lib/env';
export function useLocalAccountId() {
    var _a = useContext(GlobalContext), loading = _a.loading, setLoading = _a.setLoading;
    var localAccountId = useInput('');
    var _b = useState(null), error = _b[0], setError = _b[1];
    var _c = useState(null), redirectUri = _c[0], setRedirectUri = _c[1];
    useEffect(function () {
        var urlParams = new URLSearchParams(globalThis.location.search);
        var _redirectUri = urlParams.get('redirect_uri');
        // if (!_redirectUri) {
        //   globalThis.location.href = `${appEnv.server.ssoUrl}/login?ref=${encodeURIComponent(`${appEnv.client.portalUrl}/`)}`
        // } else
        setRedirectUri(_redirectUri);
    }, []);
    function submit(event) {
        return __awaiter(this, void 0, void 0, function () {
            var loginResponse, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!redirectUri)
                            return [2 /*return*/];
                        event.preventDefault();
                        setLoading(true);
                        setError(null);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 6, , 7]);
                        return [4 /*yield*/, fetch("".concat(appEnv.server.authUrl, "/auth/login"), {
                                method: 'POST',
                                headers: { 'Content-Type': 'application/json' },
                                body: JSON.stringify({ username: localAccountId.value, password: 'none' }),
                                credentials: 'include',
                            })];
                    case 2:
                        loginResponse = _a.sent();
                        if (!loginResponse.ok) return [3 /*break*/, 4];
                        return [4 /*yield*/, loginResponse.json()];
                    case 3:
                        _a.sent();
                        globalThis.location.href = redirectUri;
                        return [3 /*break*/, 5];
                    case 4:
                        setError('Login failed');
                        _a.label = 5;
                    case 5: return [3 /*break*/, 7];
                    case 6:
                        err_1 = _a.sent();
                        console.error(err_1);
                        return [3 /*break*/, 7];
                    case 7:
                        setLoading(false);
                        return [2 /*return*/];
                }
            });
        });
    }
    return {
        localAccountId: localAccountId,
        loading: loading,
        error: error,
        submit: submit,
    };
}
